import avatar from "./avatar.png";
import fundedByEuUnion from "./funded-by-eu-union.png";
import madeInFinland from "./made-in-finland.png";

const Images = {
  avatar,
  fundedByEuUnion,
  madeInFinland,
} as const;

export default Images;
